<template>
	<v-container grid-list-xs>
		<v-layout row wrap>
			<v-flex xs12 md12>
				<v-card flat>
					<v-card-title
						><v-layout row wrap>
							<v-flex xs12 md8> Top 10 topups </v-flex>
							<v-flex xs12 md4>
								<v-select
									v-model="filter.type"
									:items="types"
									:label="$t('Status')"
									hide-details
									clearable
								></v-select>
							</v-flex> </v-layout
					></v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<v-simple-table>
							<template v-slot:default>
								<thead>
									<tr>
										<th class="text-left">Name</th>
										<th class="text-left">Phone</th>
										<th class="text-left">Topup Count</th>
									</tr>
								</thead>
								<tbody>
									<tr
										v-for="item in customers"
										:key="item.display_name"
									>
										<td>{{ item.display_name }}</td>
										<th>{{ item.phone }}</th>
										<td>
											<v-chip
												class="ma-2"
												color="secondary"
												outlined
											>
												<span class="subtitle 1">{{
													item.topups_count
												}}</span>
											</v-chip>
										</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table></v-card-text
					>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>


<script>
import CentralLayout from "../../../../layouts/central.vue";
import CentralCustomerLayout from "../../../../layouts/partials/central/customer.vue";
import pickBy from "lodash/pickBy";
export default {
	layout: [CentralLayout, CentralCustomerLayout],
	props: ["customers"],

	data() {
		return {
			filter: {
				// type: "this_week",
			},
			types: [
				{
					text: "This week",
					value: "this_week",
				},
				{
					text: "This month",
					value: "this_month",
				},
				{
					text: "Last month",
					value: "last_month",
				},
				{
					text: "This year",
					value: "this_year",
				},
			],
		};
	},
	computed: {
		endpoint() {
			return this.$route("central.report.customer_coupon");
		},
	},

	watch: {
		filter: {
			handler() {
				this.onFilter();
			},
			deep: true,
		},
	},
	methods: {
		onFilter() {
			this.$inertia.get(
				this.endpoint,
				{
					type: this.filter.type,
				},
				{
					preserveState: true,
					preserveScroll: true,
				}
			);
		},
	},
};
</script>